import RestAPI from 'components/Common/restApi';
import { Uuid } from 'resources/index';
import { Filter } from 'components/Common/Filter/types';

export interface UpdateParams {
  customerUuid?: string;
  acknowledged?: boolean;
  callLogUuid: Uuid<'vcl'>;
}

interface IndexParams {
  filters: Filter[];
  expand: string[];
}

interface ShowParams {
  uuid: Uuid<'vcl'>;
  expand: string[];
}

export default class CallLogsApi {
  static index(params: IndexParams) {
    return RestAPI.getWithQueryString('/alpha/voice/call_logs', params);
  }

  static show({ uuid, expand }: ShowParams) {
    return RestAPI.getWithQueryString(`/alpha/voice/call_logs/${uuid}`, { expand });
  }

  static getUnacknowledgedCallsCount() {
    return RestAPI.get('/alpha/voice/call_logs/unacknowledged_missed_call_count');
  }

  static update({ callLogUuid, customerUuid, acknowledged }: UpdateParams) {
    return RestAPI.updateWithFormData(`/alpha/voice/call_logs/${callLogUuid}`, {
      customer_uuid: customerUuid,
      acknowledged,
    });
  }
}
